module.exports = __webpack_public_path__ + "static/media/stripeView.32d73988.svg";